export enum RouteTransition {
  Default = 'default',
  None = 'none',
  SlideRelatives = 'slide-relatives',
}

/**
 * A function that resolves the transition for a route based on runtime context.
 * Use this when the transition depends on dynamic conditions (e.g., mobile vs desktop).
 */
export type TransitionResolveFn = (context: { isMobile: boolean }) => RouteTransition | undefined;

export interface TransitionDefinitionObject<T extends RouteTransition = RouteTransition, U extends object = object> {
  name: T;
  options?: U;
}

export type TransitionDefinition<T extends RouteTransition = RouteTransition, U extends object = object> =
  | T
  | TransitionDefinitionObject<T, U>;

export function getTransitionConfig<T extends RouteTransition, U extends object>(
  value: TransitionDefinition<T, U>,
): TransitionDefinitionObject<T, U> {
  if (typeof value === 'object') {
    return value;
  }

  return {
    name: value,
  };
}
